import type { SubsSection, SubRowVariant } from '@/msgdeskRuntime/state'

export function mainTemplateVariant(_section: SubsSection): SubRowVariant {
  return 'auto'
}

export function menuTemplateVariant(_mode: 'drafts' | 'trash' | 'favs', _section: SubsSection): SubRowVariant {
  return 'folder'
}

export function nestedTemplateVariant(): SubRowVariant {
  return 'auto'
}
